"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    production: true,
    cafe24_api_options: {
        client_id: '8N558wuOLxeJPnH21ZL2hG',
        version: '2023-03-01',
    },
    kakaomap_api_options: {
        app_key: 'c3030d82aced7666f9f3c29842bedf29',
    },
    nsr_addon_api_options: {
        base_url: 'https://addon.shints.com/nsr-addon/'
    },
};
